import { useFeatureAccessStore } from '@/common/featureAccessStore';
import { useFeatureToggles } from '@/utils/featureToggles';

export const useCapacitiesAccess = () => {
  const { ENABLE_CAP } = useFeatureToggles();
  const featureAccessStore = useFeatureAccessStore();
  const hasCapacitiesAccess = computed(() => ENABLE_CAP && featureAccessStore.features.CAP.write);

  return {
    hasCapacitiesAccess,
  };
};
